"use client";

import { Compass, Stamp, Scale, FileText, Briefcase, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ExecutiveTrainingProgrammes() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const primaryServices = [{
    numeral: "01",
    title: "AI Tools for Managers",
    description: "Mastering practical artificial intelligence to drive productivity and operational innovation.",
    Icon: Compass
  }, {
    numeral: "02",
    title: "Strategic Leadership",
    description: "Developing high-impact communication and leadership skills for the modern global economy.",
    Icon: Stamp
  }, {
    numeral: "03",
    title: "Marketing",
    description: "Navigating the complexities of marketing and technology to ensure sustainable growth.",
    Icon: Scale
  }];
  const secondaryServices = [];
  return <section data-section-id="3568" id="executive-training-programmes" className="bg-background text-foreground py-24 md:py-36">
      <div className="container mx-auto px-6 md:px-10">
        {}
        <div ref={header.ref} className={`grid grid-cols-12 gap-6 md:gap-10 mb-20 md:mb-28 transition-all duration-1000 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="col-span-12 md:col-span-3">
            <span className="font-mono text-xs uppercase tracking-widest text-primary font-semibold">
              03 — WHAT WE OFFER
            </span>
          </div>
          <div className="col-span-12 md:col-span-9 lg:col-span-8">
            <h2 className="font-default text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.05] text-foreground">
              Executive Training <em className="font-serif italic text-primary">Programmes</em>
            </h2>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 mb-10 md:mb-12">
          {primaryServices.map((service, i) => {
          const Icon = service.Icon;
          return <article data-index={i} key={service.title} className={`group bg-card text-card-foreground border-l-4 border-primary rounded-md p-8 md:p-10 transition-all duration-500 ease-out hover:-translate-y-1 hover:shadow-md flex flex-col ${i === 1 ? "md:mt-[60px]" : ""}`}>
                <div className="flex items-center justify-between mb-10">
                  <Icon className="w-10 h-10 text-secondary" strokeWidth={1.5} />
                  <span className="font-mono text-sm text-muted-foreground tracking-widest">
                    {service.numeral}
                  </span>
                </div>

                <h3 className="font-default font-bold text-2xl md:text-[1.75rem] leading-tight text-foreground mb-4">
                  {service.title}
                </h3>

                <p className="font-default text-sm md:text-base text-muted-foreground leading-relaxed mb-10">
                  {service.description}
                </p>

                <div className="mt-auto">
                  <Link to={i === 0 ? "/AiToolsForManagersPage" : i === 1 ? "/StrategicCommunicationPage" : "/MarketingForManagersPage"} className="inline-flex items-center gap-2 font-default font-semibold text-base text-primary group/link">
                    <span className="relative">
                      View Details
                      <span className="absolute left-0 -bottom-0.5 h-px w-0 bg-primary transition-all duration-500 group-hover/link:w-full" />
                    </span>
                    <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover/link:translate-x-1" strokeWidth={2} />
                  </Link>
                </div>
              </article>;
        })}
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-10">
          {secondaryServices.map((service, i) => {
          const Icon = service.Icon;
          return <article data-index={i} key={service.title} className={`group bg-card text-card-foreground border-l-4 border-primary rounded-md p-8 md:p-10 transition-all duration-500 ease-out hover:-translate-y-1 hover:shadow-md flex flex-col ${service.span}`}>
                <div className="flex items-center justify-between mb-10">
                  <Icon className="w-10 h-10 text-secondary" strokeWidth={1.5} />
                  <span className="font-mono text-sm text-muted-foreground tracking-widest">
                    {service.numeral}
                  </span>
                </div>

                <h3 className="font-default font-bold text-2xl md:text-[1.75rem] leading-tight text-foreground mb-4">
                  {service.title}
                </h3>

                <p className="font-default text-sm md:text-base text-muted-foreground leading-relaxed mb-10 max-w-xl">
                  {service.description}
                </p>

                <div className="mt-auto">
                  <Link to="#" className="inline-flex items-center gap-2 font-default font-semibold text-base text-primary group/link">
                    <span className="relative">
                      View Details
                      <span className="absolute left-0 -bottom-0.5 h-px w-0 bg-primary transition-all duration-500 group-hover/link:w-full" />
                    </span>
                    <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover/link:translate-x-1" strokeWidth={2} />
                  </Link>
                </div>
              </article>;
        })}
        </div>
      </div>
    </section>;
}